import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuidePartnerOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="パートナー管理"
      description="パートナー企業（法人・個人事業主）の登録・更新・検索を行う管理機能です。管理者・管理部門・課長が操作可能です。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="partner/register">新規パートナーを登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              新しいパートナー企業の情報を登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="partner/bulk-register">パートナーを一括登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              CSVファイルを使用して複数のパートナーを一括で登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="partner/update">パートナー情報を更新する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              既存パートナーの企業情報を更新します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="partner/detail">パートナーの詳細情報を確認する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              パートナーの登録情報を詳細画面で確認します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="partner/search">パートナーを検索する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              条件を指定してパートナーを検索・絞り込みます。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuidePartnerOverview;
